// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ul {
   list-style: none;
   margin: 0;
   padding: 0;
}

.section-break {
   height: 2em;
}

a:hover {
   color: #ffa726;
}

a.active {
   color: #ff8326;
   cursor: initial;
}

a.active:hover {
   text-decoration: none;
}
`, "",{"version":3,"sources":["webpack://./src/app/admin/admin-menu/admin-menu.component.css"],"names":[],"mappings":"AAAA;GACG,gBAAgB;GAChB,SAAS;GACT,UAAU;AACb;;AAEA;GACG,WAAW;AACd;;AAEA;GACG,cAAc;AACjB;;AAEA;GACG,cAAc;GACd,eAAe;AAClB;;AAEA;GACG,qBAAqB;AACxB","sourcesContent":["ul {\n   list-style: none;\n   margin: 0;\n   padding: 0;\n}\n\n.section-break {\n   height: 2em;\n}\n\na:hover {\n   color: #ffa726;\n}\n\na.active {\n   color: #ff8326;\n   cursor: initial;\n}\n\na.active:hover {\n   text-decoration: none;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
